<template>
  <ais-refinement-list
    :attribute="attribute"
    :transform-items="onTransformItems"
    :operator="operator"
    :limit="256"
  >
    <template #default="{ items, isFromSearch, refine, searchForItems }">
      <div v-if="searchable" class="input-group mb-2">
        <input
          v-model="searchQuery"
          :name="`search-${attribute}`"
          type="text"
          class="form-control form-control-sm"
          :placeholder="searchablePlaceholder"
          @input="onSearchInput(searchForItems, $event.currentTarget.value)"
        />
        <button
          v-if="!!searchQuery"
          type="button"
          class="btn btn-outline-secondary p-2 lh-0"
          @click="onSearchInput(searchForItems, '', true)"
        >
          <IconClose class="search-close-icon" />
        </button>
      </div>
      <ul
        :class="{
          'expandable-list': true,
          'limit-15': limit,
          'limit-md-5': limit,
          'show-all': showAll,
        }"
      >
        <li v-if="isFromSearch && !items.length">No results.</li>
        <li v-for="item in limitItems(items)" :key="item.value">
          <div class="form-check">
            <input
              :id="`${attribute}-${kebabCase(item.value)}-checkbox`"
              type="checkbox"
              class="form-check-input"
              :checked="item.isRefined"
              :value="item.value"
              @change="onRefine(item, refine)"
            />
            <label
              class="filter-label form-check-label"
              :for="`${attribute}-${kebabCase(item.value)}-checkbox`"
            >
              <img
                v-if="getIcon"
                :src="getIcon(item.value)"
                :alt="item.value"
                loading="lazy"
                height="22"
                class="me-1"
              />
              <span>
                <span v-if="getLabel">{{ getLabel(item.value) }}</span>
                <span v-else>{{ item.label }}</span>
                <span class="count-label">{{
                  item.count.toLocaleString()
                }}</span>
              </span>
            </label>
          </div>
        </li>
        <li v-if="limit && !showAll" class="button-more">
          <a href="#" @click.prevent="showAll = true">{{
            showMoreButtonText ? showMoreButtonText : gettext('Show more...')
          }}</a>
        </li>
        <li v-if="limit && showAll" class="button-less">
          <a href="#" @click.prevent="showAll = false">{{
            showLessButtonText ? showLessButtonText : gettext('Show less...')
          }}</a>
        </li>
      </ul>
    </template>
  </ais-refinement-list>
</template>

<script>
import kebabCase from 'lodash/kebabCase';
import { AisRefinementList } from 'vue-instantsearch';
import IconClose from '../../../../../templates/icons/close.svg';

export default {
  components: {
    AisRefinementList,
    IconClose,
  },
  props: {
    // Algolia attribute to filter on
    attribute: {
      type: String,
      default: '',
    },
    // 'and' if results must have all selected fields
    // 'or' if results must have any of selected fields
    operator: {
      type: String,
      default: 'or',
    },
    // If the list is searchable
    searchable: Boolean,
    // Placeholder to show in the search input
    searchablePlaceholder: {
      type: String,
      default: '',
    },
    // To only show the first X amount of items, and show a 'show more' button
    limit: Boolean,
    // Text of show more button
    showMoreButtonText: {
      type: String,
      default: null,
    },
    // Text of show less button
    showLessButtonText: {
      type: String,
      default: null,
    },
    notifyCount: {
      type: Function,
      default: null,
    },
    // Function to provide a custom label per list item
    getLabel: {
      type: Function,
      default: null,
    },
    // Function to provide a custom icon src per list item
    getIcon: {
      type: Function,
      default: null,
    },
    transformItems: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      showAll: false,
      searchQuery: '',
      hasSearchInput: false,
    };
  },
  methods: {
    kebabCase: value => kebabCase(value),
    limitItems(items) {
      // To prevent rendering a lot of useless data we actually only
      // render 16 items, as the .expandable-list only shows 15 items
      // max by default. It's limited to 16 so that the show-more button
      // is still shown though
      return this.limit && !this.showAll ? items.slice(0, 16) : items;
    },
    onRefine(item, refine) {
      this.$nextTick(() => {
        refine(item.value);
        this.$emit('filter-update', item.value);
      });
    },
    onSearchInput(searchForItems, value, setSearchQuery) {
      if (setSearchQuery) {
        this.searchQuery = value;
      }
      searchForItems(value);
    },
    onTransformItems(items) {
      if (this.notifyCount && items.length > 0) {
        this.notifyCount(items.filter(i => i.isRefined).length);
      }
      if (this.transformItems) {
        items = this.transformItems(items);
      }
      return items;
    },
  },
};
</script>
